export default __webpack_public_path__ + "static/media/Bandit's Leggings of a Hundred Eyes.769023ec.jpg";